<template>
  <Toast />
  <div class="card-header row">
    <h4 class="col-md-10">Listado de Recepciones</h4>
    <div class="col-md-2" style="text-align:right;"><Button label="Crear" icon="pi pi-plus" class="p-button-success" @click="openNew" /></div>
    <div class="line_title mt-1 ms-3 col-md-1"></div>
  </div>

  <div class="card-body">
    <!-- DT Recepciones -->
    <DataTable ref="dt" :value="recepciones" lazy paginator :first="first" :loading="loading" 
      removableSort sortMode="multiple" @sort="onSort($event)" 
      :rows="10" :totalRecords="totalRecords" @page="onPage($event)" @filter="onFilter($event)" 
      v-model:filters="filters" :globalFilterFields="['id','tipoMadera','tipoDocRecep', 'folio_doc_recep', 'rut_dv', 'proveedor', 'fecha', 'fecha_doc_recep', 'origen', 'destino','transportista','neto', 'iva', 'total']" filterDisplay="row" tableStyle="min-width: 75rem" breakpoint="990px" style="zoom: 0.80;" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" responsiveLayout="scroll" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">           

      <template #header>
        <!-- DT Toolbar-->
        <Toolbar class="">
          <template #start>
            <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="filters['global'].value" placeholder="Buscar..." @keydown.enter="onFilter($event)"/>
              </span>
            </div>
          </template>
          <template #empty> Sin registros. </template>
          <template #loading> Cargando registros. </template>
          <template #end>
            <Button type="button" icon="pi pi-filter-slash" label="Limpiar" outlined @click="initFilters()" class="p-button-secondary"/>&nbsp;
            <Button label="Crear" icon="pi pi-plus" class="p-button-success" @click="openNew" />
          </template>
        </Toolbar>
      </template>

      <Column header="Duplicar" :exportable="false" style="white-space: nowrap;">
        <template #body="slotProps">
          <Button icon="pi pi-clone" class="p-button-rounded p-button-primary" 
            @click="duplicarGuia(slotProps.data)" title="Duplicar Recepción" />
        </template>
      </Column>     

      <Column field="id" header="Cod."  style="white-space: nowrap;" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.id }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>
      </Column>       

      <Column field="tipoMadera" header="Tipo" sortable>
        <template #body="slotProps">
          <Tag :value="slotProps.data.tipoMadera.nombre.toUpperCase()" severity="info" />
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>                  
      </Column>    

      <Column field="fecha" header="Fecha"  style="white-space: nowrap;" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.fecha }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="tipoDocRecep" header="TipoDoc" sortable>
        <template #body="slotProps">
          <Tag :value="slotProps.data.tipoDocRecep.codigo" :severity="slotProps.data.tipoDocRecep.codigo === 'GD' ? 'info' : 'warning'" />
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>                    
      </Column>           

      <Column field="folio_doc_recep" header="Folio"  style="white-space: nowrap;" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.folio_doc_recep }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="fecha_doc_recep" header="F.Doc.Recep"  style="white-space: nowrap;" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.fecha_doc_recep }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>  

      <Column field="rut_dv" header="RUT" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.proveedor.rut_dv }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="proveedor" header="Proveedor" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.proveedor.razon_social }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="origen" header="Origen" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.origen.descripcion.slice(0, 23) }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="destino" header="Destinos" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.destino.descripcion.slice(0, 23) }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="transportista" header="Transportista" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.transportista.razon_social }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>

      <Column field="neto" header="Neto" sortable>
        <template #body="slotProps">
          <span>
            {{ parseInt(slotProps.data.neto).toLocaleString('es-CL') }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>            

      <Column field="iva" header="IVA" sortable>
        <template #body="slotProps">
          <span>
            {{ parseInt(slotProps.data.iva).toLocaleString('es-CL') }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>            

      <Column field="total" header="Total" sortable>
        <template #body="slotProps">
          <span>
            {{ parseInt(slotProps.data.total).toLocaleString('es-CL') }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="" />
        </template>          
      </Column>            

      <Column header="Acciones" :exportable="false" style="white-space: nowrap;">
        <template #body="slotProps">
          <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-info"
            @click="getPDFSII(slotProps.data)" title="Ver" />&nbsp;
          <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning"
            @click="editRecepcion(slotProps.data)" />&nbsp;
          <Button icon="pi pi-print" class="p-button-rounded p-button-success"
            @click="recepcionPDF(slotProps.data.id)" />&nbsp;
          <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
            @click="confirmDeleteRecepcion(slotProps.data)"  v-if="[0, 1].includes(userRole)"/>
        </template>
      </Column>
    </DataTable>
    
    <!-- Formulario Recepciones en modal -->
    <Dialog v-model:visible="recepcionDialog" :style="{ width: '50%' }" header="Datos de la Recepción" :modal="true"
      class="p-fluid" :maximizable="true">
      
      <Divider align="left" type="solid">
        <b class="text-muted">Antecedentes Recepcion</b>
      </Divider>

      <form class="p-fluid">
        <div class="row">
          <div class="col-md-2 field">
            <label for="tipoMadera" class="mt-3">Tipo Recepción</label>
            <AutoComplete id="tipoMadera" v-model="v$.tipoMadera.$model" 
              :class="{ 'p-invalid': v$.tipoMadera.$invalid && submitted }" :suggestions="filteredTipoMaderas"
              @complete="searchTipoMadera($event)" field="_nombre" :dropdown="true" aria-describedby="tipoMadera-error" 
              autofocus autocomplete="off" @change="setProductos($event, index)"/>
            <span v-if="v$.tipoMadera.$error && submitted">
              <span id="tipoMadera-error" v-for="(error, index) of v$.tipoMadera.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.tipoMadera.$invalid && submitted) || v$.tipoMadera.$pending.$response)"
              class="p-error">
              {{ v$.tipoMadera.required.$message.replace('Value', 'Tipo Recepción') }}</small>
          </div> 

          <div class="col-md-2 field">
            <label for="fecha" class="mt-3">Fecha</label>
            <Calendar id="fecha" v-model="v$.fecha.$model" 
              :class="{ 'p-invalid': v$.fecha.$invalid && submitted }" aria-describedby="fecha-error"
              autocomplete="off" :showIcon="true" dateFormat="dd/mm/yy"/>
            <span v-if="v$.fecha.$error && submitted">
              <span id="fecha-error" v-for="(error, index) of v$.fecha.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.fecha.$invalid && submitted) || v$.fecha.$pending.$response"
              class="p-error">
              {{ v$.fecha.required.$message.replace('Value', 'Fecha') }}</small>
          </div>   

          <div class="col-md-2 field">
            <label for="nextid" class="mt-3">Nro.Recepción</label>
            <InputNumber id="nextid" v-model.trim="form.nextid"/>
          </div>         

          <div class="col-md-2 field">
            <label for="tipoDocRecep" class="mt-3">Recepción Con</label>
            <AutoComplete id="tipoDocRecep" v-model="v$.tipoDocRecep.$model"
              :class="{ 'p-invalid': v$.tipoDocRecep.$invalid && submitted }" :suggestions="filteredTipoDocReceps"
              @complete="searchTipoDocRecep($event)" field="_nombre" :dropdown="true" forceSelection
              aria-describedby="tipoDocRecep-error" autofocus autocomplete="off" />
            <span v-if="v$.tipoDocRecep.$error && submitted">
              <span id="tipoDocRecep-error" v-for="(error, index) of v$.tipoDocRecep.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.tipoDocRecep.$invalid && submitted) || v$.tipoDocRecep.$pending.$response)"
              class="p-error">
              {{ v$.tipoDocRecep.required.$message.replace('Value', 'Tipo Documento') }}</small>
          </div>

          <div class="col-md-2 field">
            <label for="folio_doc_recep" class="mt-3">Nro. Documento</label>
            <InputNumber id="folio_doc_recep" v-model="v$.folio_doc_recep.$model" :class="{ 'p-invalid': v$.folio_doc_recep.$invalid && submitted }" aria-describedby="folio_doc_recep-error" autofocus autocomplete="off" />
            <span v-if="v$.folio_doc_recep.$error && submitted">
              <span id="folio_doc_recep-error" v-for="(error, index) of v$.folio_doc_recep.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.folio_doc_recep.$invalid && submitted) || v$.folio_doc_recep.$pending.$response" class="p-error">
              {{ v$.folio_doc_recep.required.$message.replace('Value', 'Valor') }}</small>
          </div>

          <div class="col-md-2 field">
            <label for="fecha_doc_recep" class="mt-3">Fecha.Docto</label>
            <Calendar id="fecha_doc_recep" v-model="v$.fecha_doc_recep.$model" 
              :class="{ 'p-invalid': v$.fecha_doc_recep.$invalid && submitted }" aria-describedby="fecha_doc_recep-error"
              autocomplete="off" :showIcon="true" dateFormat="dd/mm/yy"/>
            <span v-if="v$.fecha_doc_recep.$error && submitted">
              <span id="fecha_doc_recep-error" v-for="(error, index) of v$.fecha_doc_recep.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.fecha_doc_recep.$invalid && submitted) || v$.fecha_doc_recep.$pending.$response"
              class="p-error">
              {{ v$.fecha_doc_recep.required.$message.replace('Value', 'Fecha') }}</small>
          </div>
        </div>        

        <div class="row">
          <div class="col-md-8 field">
            <label for="proveedor" class="mt-3">Proveedor</label>
            <AutoComplete id="proveedor" class="proveedor" v-model="v$.proveedor.$model"
              :class="{ 'p-invalid': v$.proveedor.$invalid && submitted }" :suggestions="filteredProveedores"
              @complete="searchProveedor($event)" field="_razon_social" :dropdown="true" forceSelection
              aria-describedby="proveedor-error" autofocus autocomplete="off" @update:modelValue="buscarCodFscProveedor" @change="setProductos($event, index)"/>
            <span v-if="v$.proveedor.$error && submitted">
              <span id="proveedor-error" v-for="(error, index) of v$.proveedor.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.proveedor.$invalid && submitted) || v$.proveedor.$pending.$response)"
              class="p-error">
              {{ v$.proveedor.required.$message.replace('Value', 'Proveedor') }}</small>
          </div>

          <div class="col-md-4 field">
            <label for="recepcionista" class="mt-3">Recepcionista</label>
            <AutoComplete id="recepcionista" v-model="v$.recepcionista.$model"
              :class="{ 'p-invalid': v$.recepcionista.$invalid && submitted }" :suggestions="filteredRecepcionistas"
              @complete="searchRecepcionista($event)" field="_nombre" :dropdown="true" forceSelection
              aria-describedby="recepcionista-error" autofocus autocomplete="off" />
            <span v-if="v$.recepcionista.$error && submitted">
              <span id="recepcionista-error" v-for="(error, index) of v$.recepcionista.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.recepcionista.$invalid && submitted) || v$.recepcionista.$pending.$response)"
              class="p-error">
              {{ v$.recepcionista.required.$message.replace('Value', 'Recepcionista') }}</small>
          </div> 
        </div>

        <div class="row">
          <div class="col-md-6 field">
            <label for="origen" class="mt-3">Origen</label>
            <AutoComplete id="origen" v-model="v$.origen.$model"
              :class="{ 'p-invalid': v$.origen.$invalid && submitted }" :suggestions="filteredOrigenes"
              @complete="searchOrigen($event)" field="_descripcion" :dropdown="true" forceSelection
              aria-describedby="origen-error" autofocus autocomplete="off" @change="setProductos($event, index)"/>
            <span v-if="v$.origen.$error && submitted">
              <span id="origen-error" v-for="(error, index) of v$.origen.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.origen.$invalid && submitted) || v$.origen.$pending.$response)"
              class="p-error">
              {{ v$.origen.required.$message.replace('Value', 'Origen') }}</small>
          </div>

          <div class="col-md-6 field">
            <label for="destino" class="mt-3">Destino</label>
            <AutoComplete id="destino" v-model="v$.destino.$model"
              :class="{ 'p-invalid': v$.destino.$invalid && submitted }" :suggestions="filteredDestinos"
              @complete="searchDestino($event)" field="_descripcion" :dropdown="true" forceSelection
              aria-describedby="destino-error" autofocus autocomplete="off" />
            <span v-if="v$.destino.$error && submitted">
              <span id="destino-error" v-for="(error, index) of v$.destino.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.destino.$invalid && submitted) || v$.destino.$pending.$response)"
              class="p-error">
              {{ v$.destino.required.$message.replace('Value', 'Destino') }}</small>
          </div> 
        </div>

        <div class="row mb-4">          
          <div class="col-md-6 field">
            <label for="predio" class="mt-3">Predio</label>
            <AutoComplete id="predio" 
              v-model="v$.predio.$model"
              :suggestions="filteredPredios"
              @complete="searchPredio($event)"
              field="_nombre"
              :dropdown="true"
              :forceSelection="false" 
              autocomplete="off"
              :class="{ 'p-invalid': v$.predio.$invalid && submitted }"
            />
            <span v-if="v$.predio.$error && submitted">
              <span id="predio-error" v-for="(error, index) of v$.predio.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.predio.$invalid && submitted) || v$.predio.$pending.$response)"
              class="p-error">
              {{ v$.predio.required.$message.replace('Value', 'Predio') }}</small>            
          </div>
                  
          <div class="col-md-6 field">
            <label for="rol" class="mt-3">Rol</label>
            <InputText id="rol" class="rol" v-model.trim="v$.rol.$model" @focus="setPredios()" :class="{ 'p-invalid': v$.rol.$invalid && submitted }" aria-describedby="rol-error" readonly="true"/>
            <span v-if="v$.rol.$error && submitted">
              <span id="rol-error" v-for="(error, index) of v$.rol.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.rol.$invalid && submitted) || v$.rol.$pending.$response" class="p-error">
              {{ v$.rol.required.$message.replace('Value', 'Valor') }}</small>            
          </div>         
        </div>
        <Divider align="left" type="solid">
          <b class="text-muted">Antecedentes Transportista</b>
        </Divider>

        <div class="row">
          <div class="col-md-4 field">
            <label for="transportista" class="mt-3">Transportista</label>
            <AutoComplete id="transportista" v-model="v$.transportista.$model"
              :class="{ 'p-invalid': v$.transportista.$invalid && submitted }" :suggestions="filteredTransportistas"
              @complete="searchTransportista($event)" field="_razon_social" :dropdown="true" forceSelection
              aria-describedby="transportista-error" autofocus autocomplete="off" />
            <span v-if="v$.transportista.$error && submitted">
              <span id="transportista-error" v-for="(error, index) of v$.transportista.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.transportista.$invalid && submitted) || v$.transportista.$pending.$response)"
              class="p-error">
              {{ v$.transportista.required.$message.replace('Value', 'Transportista') }}</small>
          </div> 
          <div class="field" :class="frmchofer.visible ? 'col-md-4' : 'col-md-8'">
            <Button v-if="form.id === null" :label="frmchofer.label" link :class="frmchofer.color" @click="addChofer" style="width: 80px;padding:0px;margin:2px; height:15px;"/>
            <label  v-else for="chofer" class="mt-3">Chofer</label>
            <AutoComplete id="chofer" v-model="form.chofer" @change="dummyClick"
              :suggestions="filteredChoferes"
              @complete="searchChofer($event)" field="_nombre" :dropdown="true" forceSelection
              autofocus :disabled="frmchofer.visible" />
          </div> 
          <div class="col-md-2 field" v-if="frmchofer.visible">
            <label for="chofer" class="mt-3" v-if="frmchofer.visible">RUT Chofer</label>
            <InputText id="rut_dv" v-model="v$.rut_dv.$model" @change="dummyClick"
              :class="{ 'p-invalid': v$.rut_dv.$invalid && submitted }" aria-describedby="rut_dv-error" autofocus
              autocomplete="off" />
            <span v-if="v$.rut_dv.$error && submitted">
              <span id="rut_dv-error" v-for="(error, index) of v$.rut_dv.$errors" :key="index">
                <small class="p-error">{{ error.$message }} </small>
              </span>
            </span>
            <small v-else-if="(v$.rut_dv.$invalid && submitted) || v$.rut_dv.$pending.$response" class="p-error">
              {{ v$.rut_dv.required.$message.replace('Value', 'RUT') }}</small>
          </div>               
          <div class="col-md-2 field" v-if="frmchofer.visible">
            <label for="chofer" class="mt-3" v-if="frmchofer.visible">Nombre Chofer</label>
            <InputText id="nombre" v-model="form.nombre" autofocus autocomplete="off" @change="dummyClick" />                                     
          </div>                     
        </div>

        <div class="row mb-4">
          <div class="col-md-3 field">
            <label for="patente_camion" class="mt-3">Patente Camion</label>
            <InputText id="patente_camion" v-model="v$.patente_camion.$model" :class="{ 'p-invalid': v$.patente_camion.$invalid && submitted }"
              aria-describedby="patente_camion-error" autocomplete="off" minlength="6" maxlength="6" size="6" @update:modelValue="upperCase($event,'patente_camion')"/>
            <span v-if="v$.patente_camion.$error && submitted">
              <span id="patente_camion-error" v-for="(error, index) of v$.patente_camion.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.patente_camion.$invalid && submitted) || v$.patente_camion.$pending.$response" class="p-error">
              {{ v$.patente_camion.required.$message.replace('Value', 'Valor') }}</small>
          </div>

          <div class="col-md-3 field">
            <label for="patente_carro" class="mt-3">Patente Carro</label>
            <InputText id="patente_carro" v-model="v$.patente_carro.$model" :class="{ 'p-invalid': v$.patente_carro.$invalid && submitted }"
              aria-describedby="patente_carro-error" autocomplete="off" minlength="6" maxlength="6" size="6" @update:modelValue="upperCase($event,'patente_carro')"/>
            <span v-if="v$.patente_carro.$error && submitted">
              <span id="patente_carro-error" v-for="(error, index) of v$.patente_carro.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.patente_carro.$invalid && submitted) || v$.patente_carro.$pending.$response" class="p-error">
              {{ v$.patente_carro.required.$message.replace('Value', 'Valor') }}</small>
          </div>        

          <div class="col-md-3 field">
            <label for="flete_m3" class="mt-3">Valor Flete x M3</label>
            <InputNumber id="flete_m3" v-model="v$.flete_m3.$model" :class="{ 'p-invalid': v$.flete_m3.$invalid && submitted }"
              aria-describedby="flete_m3-error" autofocus autocomplete="off" />
            <span v-if="v$.flete.$error && submitted">
              <span id="flete_m3-error" v-for="(error, index) of v$.flete_m3.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.flete_m3.$invalid && submitted) || v$.flete_m3.$pending.$response" class="p-error">
              {{ v$.flete_m3.required.$message.replace('Value', 'Valor Flete M3') }}</small>
          </div>   

          <div class="col-md-3 field">
            <label for="flete" class="mt-3">Valor Flete</label>
            <InputNumber id="flete" v-model="v$.flete.$model" :class="{ 'p-invalid': v$.flete.$invalid && submitted }"
              aria-describedby="flete-error" autofocus autocomplete="off" />
            <span v-if="v$.flete.$error && submitted">
              <span id="flete-error" v-for="(error, index) of v$.flete.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.flete.$invalid && submitted) || v$.flete.$pending.$response" class="p-error">
              {{ v$.flete.required.$message.replace('Value', 'Valor Flete') }}</small>
          </div>                  
        </div>

        <div class="row mb-4">
          <div class="col-md-6 field">
            <label for="fsc_nombre" class="mt-3">Certificación FSC</label>
            <InputText 
              v-model="form.fsc_nombre" 
              :class="{'p-invalid': v$.fsc_nombre.$invalid && submitted}"
              readonly 
              class="p-disabled" 
            />
            <!-- Mensaje de Vuelidate -->
            <span v-if="v$.fsc_nombre.$error && submitted">
              <span id="fsc_nombre-error" v-for="(error, index) of v$.fsc_nombre.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.fsc_nombre.$invalid && submitted) || v$.fsc_nombre.$pending.$response" class="p-error">
              {{ v$.fsc_nombre.required.$message.replace('Value', 'Valor') }}</small>            
          </div>
          
          <div class="col-md-6 field">
            <label for="fsc_codigo" class="mt-3">Código FSC</label>
            <InputText 
              v-model="form.fsc_codigo" 
              :class="{'p-invalid': v$.fsc_codigo.$invalid && submitted}"
              readonly 
              class="p-disabled" 
            />
            <!-- Mensaje de Vuelidate -->
            <span v-if="v$.fsc_codigo.$error && submitted">
              <span id="fsc_codigo-error" v-for="(error, index) of v$.fsc_codigo.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.fsc_codigo.$invalid && submitted) || v$.fsc_codigo.$pending.$response" class="p-error">
              {{ v$.fsc_codigo.required.$message.replace('Value', 'Valor') }}</small>             
          </div>

          <!-- MENSAJE DINÁMICO -->
          <div class="col-12 mt-2" v-if="form.fsc_status === 'error' && form.predio">
            <Message severity="error" :closable="false">
                Atención: El predio <b>{{ form.predio.nombre }}</b> no tiene un código FSC asignado. 
                Debe configurar la certificación en el maestro de predios.
            </Message>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-10 field">
            <Divider align="left" type="solid">
              <b class="text-muted">Detalles</b>
            </Divider>
          </div>
          <div class="col-md-2 d-flex justify-content-end">
            <Button icon="pi pi-plus" class="p-button-rounded p-button" size="small" @click="addLinea()" v-if="(form.origen !== null  && form.proveedor !== null  && form.tipoMadera !== null)" />
          </div>
          <div class="col-md-12 field">
            <InlineMessage v-for="msg of messages" :key="msg.id" severity="warn">{{ msg.content }}</InlineMessage>
          </div>
        </div>
        <!-- DETALLES -->
        <div class="card p-fluid table_modal">
          <DataTable :value="lineas" showGridlines stripedRows scrollable scrollHeight="400px" editMode="cell" @cell-edit-complete="onCellEditComplete" tableClass="editable-cells-table" tableStyle="min-width: 50rem">
            <Column style="flex: 0 0 4rem">
              <template #body="{ index }" >
                <Button icon="pi pi-trash" class="p-button-rounded p-button-danger" size="small" @click="toggleDelete(index)"/>
              </template>
            </Column> 
            <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" :hidden="col.hidden" :style="col.field !== 'producto' ? 'max-width: 8%;text-align:right' :'max-width: 10%'">
              <!-- VISTA: Aplicamos tu lógica unificada -->
              <template #body="{ data, field }">
                <template v-if="field !== 'producto'">
                  {{
                    formatForm(
                      data[field],
                      getDecimals(field),
                      field
                    )
                  }}
                </template>
                <template v-else>
                  {{ data[field] }}
                </template>
              </template>            

              <!-- EDITOR: Misma lógica de decimales que el Body -->
              <template #editor="{ data, field }">
                <template v-if="field !== 'producto'">
                  <InputNumber v-model="data[field]" 
                    autofocus 
                    :selectOnFocus="true" 
                    :useGrouping="false"
                    @focus="$event.target.select()"
                    @input="data[field] = $event.value"
                    :minFractionDigits="getDecimals(field)"
                    :maxFractionDigits="getDecimals(field)"
                    :readonly="/9|10|11/.test(form.tipoMadera.id) ? /total|total_mask/.test(field) :/total|total_mask/.test(field)"
                  />
                </template>
                <template v-else>
                  <AutoComplete v-model="data[field]" optionLabel="_nombre" :optionValue="data[field]" :suggestions="filteredProductos" @complete="searchProducto($event)"/>
                </template>
              </template>
            </Column>
            <ColumnGroup type="footer" v-if="csr2 > 0">
              <Row>
                <Column footer="" :colspan="csr1+2" footerStyle="text-align:right;background-color: #efefef" v-if="csr2 > 4"/>
                <Column :footer="`${parseInt(totalCantDespacho)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr1 > 3 || form.tipoMadera.id === 9"/>
                <Column :footer="`${parseFloat(totalM3Despacho).toFixed(3)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr2 > 4 && form.tipoMadera.id !== 11"/>
                <Column :footer="`${parseFloat(totalMRDespacho).toFixed(3)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr2 > 4 && form.tipoMadera.id === 11"/>                               
                <Column :footer="`${parseInt(totalCantRecepcion)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr1 > 3 || form.tipoMadera.id === 9"/>
                <Column :footer="`${parseFloat(totalM3Recepcion).toFixed(3)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr2 > 4 && form.tipoMadera.id !== 11"/>
                <Column :footer="`${parseFloat(totalMRRecepcion).toFixed(3)}`" footerStyle="text-align:right;background-color: #efefef" v-if="csr2 > 4 && form.tipoMadera.id === 11"/>
                <Column footer="Neto" footerStyle="text-align:right;background-color: #efefef"/>
                <Column :footer="netoRecepcion" footerStyle="text-align:right;background-color: #efefef"/>
              </Row>
              <Row>
                <Column :footer="`IVA (${form.poriva})%`" :colspan="csr2" footerStyle="text-align:right;background-color: #efefef"/>
                <Column :footer="ivaRecepcion" footerStyfieldformle="text-align:right;background-color: #efefef"/>
              </Row>
              <Row>
                <Column footer="Total" :colspan="csr2" footerStyle="text-align:right;background-color: #efefef"/>
                <Column :footer="totalRecepcion" footerStyle="text-align:right;background-color: #efefef"/>
              </Row>
            </ColumnGroup>                       
          </DataTable>

        </div>

        <div class="row">
          <div class="col-md-12 field">
            <label for="observacion" class="mt-3">Observaciones</label>
            <Textarea autoResize id="observacion" v-model.trim="form.observacion" />
          </div>                   
        </div>
      </form>

      <template #footer>
        <div class="row">
          <div class="col-md-2 fw-lighter text-muted field mt-2" style="text-align: left;">
          Tipo Registro: &nbsp;<Tag :value="form.tipo_registro" severity="info" />
          </div>
          <div class="col-md-5 fw-lighter text-muted" style="text-align: left;">
            <small v-if="form.created_id" ><i class="pi pi-user-plus" style="font-size: 1rem"></i>: {{form.created_id.name}} el {{form.created_at}}</small><br/>
            <small v-if="form.updated_id"><i class="pi pi-user-edit" style="font-size: 1rem"></i>: {{form.updated_id.name}} el {{form.updated_at}}</small>    
          </div>  
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-5 field'" v-if="!saving">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-danger" @click="hideDialog(false)" />
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveRecepcion"/>
          </div>
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-5 field'" v-else>
            <ProgressBar mode="indeterminate"/>
          </div>
        </div>
        <span id="dummy"></span>
      </template>
    </Dialog>

    <!-- Confirmar elimina un recepcion -->
    <Dialog v-model:visible="deleteRecepcionDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="recepcion"> ¿Está seguro de borrar el recepcion?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecepcionDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteRecepcion" />
      </template>
    </Dialog>

    <!-- Confirmar elimina masivamente recepciones -->
    <Dialog v-model:visible="deleteRecepcionesDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-2 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="selectedRecepciones"> ¿Está seguro de borrar los recepciones seleccionados?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecepcionesDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteSelectedRecepciones" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import useRecepciones from '../../composables/recepciones/index'
import { watch, ref, reactive, onMounted, computed, isProxy, toRaw, nextTick } from 'vue'
import moment from 'moment'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import useInformes from '../../composables/informes/index'

export default {
  data() {
		return {
			userRole: window.Laravel.user.seg_rol_id,
		}
	},
  setup() {
    const predioFscs = ref([])
    
    const manualCleaning = ref(false);
    const oldProveedorId = ref(null);    // Para controlar la cascada Proveedor -> Predio
    const oldOrigenId = ref(null); // Para controlar la cascada Origen -> Predio

    const {
      porciva,
      nextid,
      recepcion,
      chofer,
      tipoMadera,
      fsc,
      recepciones,
      tipoDocReceps,
      proveedores,
      predios,
      recepcionistas,
      choferes,
      tipoMaderas,
      fscs,
      destinos,
      origenes,
      transportistas,
      productos,
      columns,
      dt, 
      loading, 
      saving,
      filters,
      selectedRecepciones,
      deleteRecepcionesDialog,
      deleteRecepcionDialog,
      recepcionDialog,
      submitted,
      filteredTipoDocReceps,
      filteredProveedores,
      filteredPredios,
      filteredRecepcionistas,
      // filteredFscs,
      filteredChoferes,
      filteredTipoMaderas,
      filteredDestinos,
      filteredOrigenes,
      filteredTransportistas,
      filteredProductos,
      selectedProductos,
      getProdsRecep,
      lineas,
      messages,
      storeRecepcion,      
      deleteSelectedRecepciones,
      deleteRecepcion,
      getCodFsc,
      csr1,
      csr2,
      totalRecords,
      first,
      lazyParams,
      loadLazyData,
      onPage,
      onSort,
      onFilter,
      getPDFSII,
      initFilters
    } = useRecepciones()

    const {
      recepcionPDF,
      informeData
    } = useInformes()

    const oldTMadera = reactive({})
    const rut_format = helpers.regex(/^(\d{1,3}(?:\d{1,3}){2}-[\dkK])$/)
    const greaterThanZero = (value) => value > 0    

    const frmchofer = reactive({
      'label' : '+ Chofer',
      'visible' : false,
      'color' : 'text-success mt-4'
    })

    const form = reactive({
      id: null,
      nextid: null,
      tipoDocRecep: '',
      proveedor: null,
      origen: null,      
      destino: '',
      transportista: '',
      chofer: '',
      tipoMadera: '',
      recepcionista: '',
      fsc: null,
      fsc_nombre: '',
      fsc_codigo: '',
      folio_doc_recep: null,
      fecha_doc_recep: null,
      fecha: moment().toDate(),
      patente_camion: '',
      patente_carro: '',
      flete: 0,
      flete_m3: 0,
      poriva: porciva.value,
      neto: null,
      iva: null,
      total: null,
      predio: null,
      rol: '',
      observacion: '',
      tipo_registro: '',
      rut_dv: '',
      nombre: '',      
      detalles: []
    })
    
    const editRecepcion = async (rec) => {
      manualCleaning.value = true;
      oldProveedorId.value = rec.proveedor_id || rec.proveedor?.id;
      oldOrigenId.value = rec.origen_id || rec.origen?.id;

      hideDialog(true);
      lineas.value = [];
      recepcion.value = { ...rec };
      messages.value = []

      // 1. Reset inicial (Campos FSC incluidos para reactividad)
      Object.assign(form, {
        id: rec.id,
        nextid: rec.id,
        tipoDocRecep: rec.tipoDocRecep,
        proveedor: rec.proveedor,
        origen: rec.origen,
        destino: rec.destino,
        transportista: rec.transportista,
        chofer: rec.chofer,
        tipoMadera: rec.tipoMadera,
        recepcionista: rec.recepcionista,
        fsc: null,
        fsc_nombre: '',
        fsc_codigo: '',
        folio_doc_recep: rec.folio_doc_recep,
        fecha_doc_recep: rec.fecha_doc_recep,
        fecha: rec.fecha,
        patente_camion: rec.patente_camion,
        patente_carro: rec.patente_carro,
        flete: rec.flete,
        flete_m3: 0,
        poriva: rec.poriva === 0 ? porciva.value : rec.poriva,
        neto: rec.neto,
        iva: rec.iva,
        total: rec.total,
        predio: '',
        rol: '',
        observacion: rec.observacion,
        tipo_registro: rec.tipo_registro ? rec.tipo_registro.toUpperCase() : '',
        detalles: []
      });

      // 2. Construcción de líneas de productos
      let detalles = isProxy(recepcion.value.productos) ? toRaw(recepcion.value.productos) : [];

      lineas.value = detalles.map(ln => ({
        producto_obj: { id: ln.id, nombre: ln.nombre },
        producto: `${ln.id}-${ln.nombre}`,
        diametro: ln.pivot.diametro,
        espesor: ln.pivot.espesor,
        largo: ln.pivot.largo,
        alto: ln.pivot.alto,
        ancho: ln.pivot.ancho,
        
        // ESTOS SON LOS CRÍTICOS PARA EL FOOTER:
        // Forzamos que sean Números Reales, NO Strings.
        cant_despacho: Number(ln.pivot.cant_despacho) || 0,
        mc_despacho: Number(ln.pivot.mc_despacho) || 0,
        pulg_despacho: Number(ln.pivot.pulg_despacho) || 0, // Si lo usas
        mruma_despacho: Number(ln.pivot.mruma_despacho) || 0, // Si lo usas

        cant_recepcion: Number(ln.pivot.cant_recepcion) || 0,
        mc_recepcion: Number(ln.pivot.mc_recepcion) || 0,
        mruma_recepcion: Number(ln.pivot.mruma_recepcion) || 0, // Para MR
        
        precio: Number(ln.pivot.precio) || 0,
        total: Number(ln.pivot.total) || 0,
        total_mask: Number(ln.pivot.total) || 0
      }));

      form.detalles = lineas.value;

      // 3. Configuraciones de UI
      oldTMadera.value = form.tipoMadera;
      configColumns();

      // 4. EL "GATILLO" FINAL: Forzamos la carga del Predio y FSC
      setTimeout(async () => {
        setPredios(); 

        if (rec.ppredio) {
          // BUSQUEDA DE RESCATE: 
          // Buscamos en la lista filtrada el objeto que tiene los volúmenes
          const predioConVolumen = predios.value.find(p => p.id === rec.ppredio.id);
          
          if (predioConVolumen) {
            // Si lo encuentra, asignamos el objeto completo (con volumen_maximo y recibido)
            form.predio = { ...predioConVolumen }; 
          } else {
            // Fallback por si no lo encuentra en la lista filtrada
            form.predio = rec.ppredio;
          }
          
          setRol(form.predio, true); 
          
        } else {
          form.rol = rec.rol || '';
          form.fsc_codigo = rec.fsc_codigo || 'N/A';
          form.fsc_nombre = rec.fsc?.nombre || 'N/A';
        }
        
        await nextTick();
        setTimeout(() => { manualCleaning.value = false; }, 300);
      }, 200);

    };

const duplicarGuia = async (rec) => {
  manualCleaning.value = true;
  // Sincronizamos IDs para que la carga inicial no dispare la limpieza de cascada
  oldProveedorId.value = rec.proveedor_id || rec.proveedor?.id;
  oldOrigenId.value = rec.origen_id || rec.origen?.id;

  recepcionDialog.value = true; // Abrimos el modal
  lineas.value = [];
  recepcion.value = { ...rec };
  messages.value = [];

  // 1. Reset e inicialización del formulario (Igual a Edit pero con ID y Folios NULL)
  Object.assign(form, {
    id: null, // <--- CLAVE: Para que sea creación
    nextid: nextid.value,
    tipoDocRecep: rec.tipoDocRecep,
    proveedor: rec.proveedor,
    origen: rec.origen,
    destino: rec.destino,
    transportista: rec.transportista,
    chofer: rec.chofer,
    tipoMadera: rec.tipoMadera,
    recepcionista: rec.recepcionista,
    fsc: null,
    fsc_nombre: '',
    fsc_codigo: '',
    folio_doc_recep: null, // <--- CLAVE: Obligamos a ingresar nuevo folio
    fecha_doc_recep: null, // <--- CLAVE: Limpiar fecha documento
    fecha: moment().toDate(), // <--- CLAVE: Fecha de hoy
    patente_camion: rec.patente_camion,
    patente_carro: rec.patente_carro,
    flete: rec.flete,
    flete_m3: 0,
    poriva: rec.poriva === 0 ? porciva.value : rec.poriva,
    neto: rec.neto,
    iva: rec.iva,
    total: rec.total,
    predio: '',
    rol: '',
    observacion: rec.observacion,
    tipo_registro: 'WEB', // Siempre WEB al duplicar
    detalles: []
  });

  // 2. Construcción de líneas (Copiado exacto de tu Edit para evitar el NaN)
  let detalles = isProxy(recepcion.value.productos) ? toRaw(recepcion.value.productos) : (recepcion.value.productos || []);

  lineas.value = detalles.map(ln => ({
    producto_obj: { id: ln.id, nombre: ln.nombre },
    producto: `${ln.id}-${ln.nombre}`,
    diametro: ln.pivot.diametro,
    espesor: ln.pivot.espesor,
    largo: ln.pivot.largo,
    alto: ln.pivot.alto,
    ancho: ln.pivot.ancho,
    
    // FORZAMOS NÚMEROS (Tu lógica ganadora contra el NaN)
    cant_despacho: Number(ln.pivot.cant_despacho) || 0,
    mc_despacho: Number(ln.pivot.mc_despacho) || 0,
    pulg_despacho: Number(ln.pivot.pulg_despacho) || 0, 
    mruma_despacho: Number(ln.pivot.mruma_despacho) || 0,

    cant_recepcion: Number(ln.pivot.cant_recepcion) || 0,
    mc_recepcion: Number(ln.pivot.mc_recepcion) || 0,
    mruma_recepcion: Number(ln.pivot.mruma_recepcion) || 0, 
    
    precio: Number(ln.pivot.precio) || 0,
    total: Number(ln.pivot.total) || 0,
    total_mask: Number(ln.pivot.total) || 0
  }));

  form.detalles = lineas.value;

  // 3. Configuraciones de UI
  oldTMadera.value = form.tipoMadera;
  configColumns();

  // 4. GATILLO FINAL: Carga de Predio y FSC
  setTimeout(async () => {
    setPredios(); 

    if (rec.ppredio) {
      // BUSQUEDA DE RESCATE: Sincronizamos volúmenes
      const predioConVolumen = predios.value.find(p => p.id === rec.ppredio.id);
      
      if (predioConVolumen) {
        form.predio = { ...predioConVolumen }; 
      } else {
        form.predio = rec.ppredio;
      }
      
      setRol(form.predio, true); 
      
    } else {
      form.rol = rec.rol || '';
      form.fsc_codigo = rec.fsc_codigo || 'N/A';
      form.fsc_nombre = rec.fsc?.nombre || 'N/A';
    }
    
    await nextTick();
    // Cerramos el escudo del watcher
    setTimeout(() => { manualCleaning.value = false; }, 300);
  }, 250); // Un pelín más de tiempo que el Edit para asegurar estabilidad
};

    
    const openNew = () => {
      // 1. ABRIMOS LA LLAVE: Avisamos al Watcher que la limpieza es intencional
      manualCleaning.value = true;
      oldProveedorId.value = null; 
      oldOrigenId.value = null;

      recepcion.value = {}; 
      submitted.value = false;
      recepcionDialog.value = true;
      saving.value = false;
      lineas.value = [];
      csr1.value = 0;
      csr2.value = 0;

      // 2. REINICIAMOS EL FORMULARIO
      Object.assign(form, {
        id: null,
        nextid: nextid.value,
        tipoDocRecep: '',
        proveedor: null,
        origen: null,
        destino: '',
        transportista: '',
        chofer: '',
        tipoMadera: null,
        recepcionista: '',
        predio: null,        // El Watcher dejará que sea null gracias al flag
        rol: '',
        fsc: null,           
        fsc_nombre: '',      
        fsc_codigo: '',      
        fsc_status: null,    // Importante resetear el status también
        folio_doc_recep: null,
        fecha_doc_recep: null,
        fecha: moment().toDate(),
        patente_camion: '',
        patente_carro: '',
        flete: 0,
        flete_m3: 0,
        poriva: porciva.value,
        neto: 0,
        iva: 0,
        total: 0,
        observacion: '',
        tipo_registro: 'WEB', 
        detalles: []
      });

      oldTMadera.value = {};
      frmchofer.label = '+ Chofer';
      frmchofer.color = 'text-success mt-4';
      frmchofer.visible = false;

      predioFscs.value = [];
      predios.value = []; 

      // 3. CERRAMOS LA LLAVE: Después de un breve delay para que el Watcher termine
      setTimeout(() => { 
        manualCleaning.value = false; 
        // console.log('manualCleaning cerrado en openNew');
      }, 500);
    };

    const rules = {
      tipoDocRecep: { required: helpers.withMessage('El campo es requerido o no corresponde a la recepcion', required), },
      proveedor: { required: helpers.withMessage('El campo es requerido!', required), },
      origen: { required: helpers.withMessage('El campo es requerido!', required), },            
      destino: { required: helpers.withMessage('El campo es requerido!', required), },  
      transportista: { required: helpers.withMessage('El campo es requerido!', required), },                 
      tipoMadera: { required: helpers.withMessage('El campo es requerido!', required), },                
      recepcionista: { required: helpers.withMessage('El campo es requerido!', required), },
      folio_doc_recep: { required: helpers.withMessage('El campo es requerido', required), },
      fecha_doc_recep: { required: helpers.withMessage('El campo es requerido', required), }, 
      fecha: { required: helpers.withMessage('El campo es requerido', required), }, 
      patente_camion: { required: helpers.withMessage('El campo es requerido', required), },
      patente_carro: { required: helpers.withMessage('El campo es requerido', required), },           
      flete: { required: helpers.withMessage('El campo es requerido', required), },
      flete_m3: { required: helpers.withMessage('El campo es requerido', required), },
      neto: { required: helpers.withMessage('El campo es requerido', required), },
      iva: { required: helpers.withMessage('El campo es requerido', required), 
             minValue: helpers.withMessage('El iva debe ser mayor a cero', greaterThanZero), },
      total: { required: helpers.withMessage('El campo es requerido', required), },
      rut_dv: {
        rut_rule: helpers.withMessage('Ingrese un rut válido. Ej: 12345678-0', rut_format),
      }, 
      predio: { required: helpers.withMessage('Debe seleccionar un origen con predios válidos para este proveedor', required) },
      rol: { required: helpers.withMessage('Debe seleccionar un predio para asignar el rol', required) },
      fsc: { required: helpers.withMessage('Debe tener un ID de certificación válido', required) },  // Validamos el ID (Lo que va al backend)
      fsc_nombre: {   // Validamos el Nombre (El bloqueo de negocio)
        required: helpers.withMessage('El tipo certificación es requerida. Debe ser configurada en el mantenedor de empresas y predios', required),
        notNA: helpers.withMessage('Debe configurar el maestro (No puede ser N/A)', 
          (value) => value !== 'N/A' && value !== 'PENDIENTE DE CONFIGURAR' && value !== ''
        )},
      fsc_codigo: { required: helpers.withMessage('El código es requerido', required) }, // El código (v-model simple)       
    }

    const addChofer = () => {
      form.rut_dv = null
      form.nombre = null        
      frmchofer.label = frmchofer.visible ? '+ Chofer' : '- Chofer'
      frmchofer.color = frmchofer.visible ? 'text-success mt-4' : 'text-danger mt-4'
      frmchofer.visible = !frmchofer.visible     
    }

    const confirmDeleteSelected = () => {
      deleteRecepcionesDialog.value = true
    }

    const confirmDeleteRecepcion = (emp) => {
      recepcion.value = emp
      deleteRecepcionDialog.value = true
    }

    const hideDialog = (visible = false) => {
      recepcionDialog.value = visible
      recepcion.value = {}
      submitted.value = false
      saving.value = false
      
      lineas.value = []
      csr1.value = 0
      csr2.value = 0 

      form.id = null
      form.nextid = nextid.value
      form.tipoDocRecep = ''
      form.proveedor = null
      form.origen = null     
      form.destino = ''
      form.transportista = ''
      form.chofer = ''
      form.tipoMadera = null
      form.recepcionista = ''
      form.fsc = null
      form.fsc_codigo = ''
      form.folio_doc_recep = null
      form.fecha_doc_recep = null
      form.fecha = moment().toDate()
      form.patente_camion = ''
      form.patente_carro = ''
      form.flete = 0,
      form.flete_m3 = 0,
      form.poriva = porciva.value
      form.neto = null
      form.iva = null
      form.total = null
      form.predio = ''
      form.rol = ''
      form.observacion = ''
      form.tipo_registro = ''
      form.detalles = []
      
      oldTMadera.value = {}

      frmchofer.label = '+ Chofer'
      frmchofer.color = 'text-success mt-4'
      frmchofer.visible = false           
    }

    const searchTipoDocRecep = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTipoDocReceps.value = [...tipoDocReceps.value]
        }
        else {
          filteredTipoDocReceps.value = tipoDocReceps.value.filter((tdocumento) => {
            return tdocumento._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchProveedor = (event) => {
      // console.info(form.proveedor)
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredProveedores.value = [...proveedores.value]
        }
        else {
          filteredProveedores.value = proveedores.value.filter((proveedor) => {
            return proveedor._razon_social.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchRecepcionista = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredRecepcionistas.value = [...recepcionistas.value]
        }
        else {
          filteredRecepcionistas.value = recepcionistas.value.filter((recepcionista) => {
            return recepcionista._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchChofer = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredChoferes.value = [...choferes.value]
        }
        else {
          filteredChoferes.value = choferes.value.filter((chofer) => {
            return chofer._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchTipoMadera = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTipoMaderas.value = [...tipoMaderas.value]
        }
        else {
          filteredTipoMaderas.value = tipoMaderas.value.filter((tmadera) => {
            return (tmadera._nombre).toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchDestino = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredDestinos.value = [...destinos.value]
        }
        else {
          filteredDestinos.value = destinos.value.filter((destino) => {
            return destino._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchOrigen = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredOrigenes.value = [...origenes.value]
        }
        else {
          filteredOrigenes.value = origenes.value.filter((origen) => {
            return origen._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchPredio = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredPredios.value = [...predios.value]
        }
        else {
          filteredPredios.value = predios.value.filter((predio) => {
            return predio._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchTransportista = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTransportistas.value = [...transportistas.value]
        }
        else {
          filteredTransportistas.value = transportistas.value.filter((transportista) => {
            return transportista._razon_social.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchProducto = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredProductos.value = [...selectedProductos.value]
        }
        else {
          filteredProductos.value = selectedProductos.value.filter((producto) => {
            return producto._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const onCellEditComplete = (event) => {
      let { data, newValue, field } = event

      let { m3_desp, m3_recep, precio } = 0
      data[field] = newValue
      messages.value = []
      data['largo'] = parseFloat(data.largo).toFixed(3)
      data['alto'] = parseFloat(data.alto).toFixed(3)
      data['ancho'] = parseFloat(data.ancho).toFixed(2)
      data['espesor'] = parseFloat(data.espesor).toFixed(2)
      
      if(!field.includes('producto')){
        //aqui los calculos segun el tipo de madera seleccionado
        if(form.tipoMadera.id === 7){//baza
          data['espesor'] = parseFloat(data['espesor']).toFixed(2)
          data['ancho'] = parseFloat(data['ancho']).toFixed(2)
          data['largo'] = parseFloat(data['largo']).toFixed(3)
          data['cant_despacho'] = parseInt(data['cant_despacho'])
          data['pulg_despacho'] = parseFloat(((data['espesor'] * data['ancho'] * data['largo'] * data['cant_despacho'])/32)).toFixed(3)
          data['mc_despacho'] = parseFloat(((data['espesor'] * data['ancho'] * data['largo'] * data['cant_despacho'])/32)/48.432).toFixed(2)
          data['cant_recepcion'] = parseInt(data['cant_recepcion'])
          data['pulg_recepcion'] = parseFloat(((data['espesor'] * data['ancho'] * data['largo']* data['cant_recepcion'])/32)).toFixed(3)
          data['mc_recepcion'] = parseFloat(((data['espesor'] * data['ancho'] * data['largo']* data['cant_recepcion'])/32)/48.432).toFixed(2)
          data['precio'] = parseInt(data['precio'])
          data['total'] = Math.round(data['precio'] * data['cant_recepcion']).toFixed(0)
          data['total_mask'] = data['total'].toLocaleString('es-CL')
        }else if(form.tipoMadera.id === 9 ){ //trozo
        //aqui lo del precio        
          if(field === 'diametro'){
            if(data['diametro'] > 13) {
              productos.value.filter(function (itm) { 
                if([data['producto_obj'].id].indexOf(itm.id) > -1 ){
                  precio = itm.precios !== null ? itm.precios.filter((pd) => { return parseInt(pd.diametro) === parseInt(data['diametro']) ? parseInt(pd.valor_m3) : 0 }) : []
                }else return 0
              })
              data['precio'] = precio.length > 0 ? parseInt(precio[0].valor_m3) : 0
            }else data['precio'] = 0
          }         
          
          if((data.diametro)%2==0 && data.diametro > 13){            
            m3_desp = Math.round(((parseFloat(data['diametro']).toFixed(0) * parseFloat(data['diametro']).toFixed(0) * parseFloat(data['largo']).toFixed(2)).toFixed(3)/10000)*1000)/1000
            m3_recep = Math.round(((parseFloat(data['diametro']).toFixed(0) * parseFloat(data['diametro']).toFixed(0) * parseFloat(data['largo']).toFixed(2)).toFixed(3)/10000)*1000)/1000

            data['cant_despacho'] = parseFloat(data.cant_despacho).toFixed(0)
            data['cant_recepcion'] = field === 'cant_recepcion' && newValue !== data.cant_despacho ? parseFloat(data.cant_recepcion).toFixed(0) : parseFloat(data.cant_despacho).toFixed(0)
            data['mc_despacho'] = parseFloat(m3_desp * data['cant_despacho']).toFixed(3) 
            data['mc_recepcion'] = parseFloat(m3_recep * data['cant_recepcion']).toFixed(3) 
            // console.info('m3 >>>>>>', m3_desp, m3_desp)
            data['total'] = (data['precio'] * data['mc_recepcion']).toFixed(0)
            data['total_mask'] = data['total'].toLocaleString('es-CL')
          }else { 
            messages.value = [{ content: 'Ingrese un diámetro válido (valor par) ', id: 0 }]
            data['diametro'] = 0
            return false
          }        
        }else if(form.tipoMadera.id === 10){ //lampazo
          data['alto'] = parseFloat(data['alto']).toFixed(2)
          data['ancho'] = parseFloat(data['ancho']).toFixed(2)
          data['largo'] = parseFloat(data['largo']).toFixed(3)
          data['cant_despacho'] = 1
          data['mc_despacho'] = parseFloat((data['alto'] * data['ancho'] * data['largo'])).toFixed(3)
          data['cant_recepcion'] = 1
          data['mc_recepcion'] = parseFloat((data['alto'] * data['ancho'] * data['largo'])).toFixed(3)
          data['precio'] = parseInt(data['precio'])
          data['total'] = parseInt(data['precio'] * data['cant_recepcion'] * data['mc_recepcion']).toFixed(0)
          data['total_mask'] = data['total'].toLocaleString('es-CL')
        }else if(form.tipoMadera.id === 11){ //mruma
          data['alto'] = parseFloat(data['alto']).toFixed(2)
          data['ancho'] = parseFloat(data['ancho']).toFixed(2)
          data['largo'] = parseFloat(data['largo']).toFixed(3)
          data['cant_despacho'] = 1
          data['mruma_despacho'] = parseFloat((data['alto'] * data['ancho'] * data['largo'])/2.44).toFixed(3)
          data['cant_recepcion'] = 1
          data['mruma_recepcion'] = parseFloat((data['alto'] * data['ancho'] * data['largo'])/2.44).toFixed(3)
          data['precio'] = parseInt(data['precio'])
          data['total'] = parseInt(data['precio'] * data['cant_recepcion'] * data['mruma_recepcion']).toFixed(0)
          data['total_mask'] = data['total'].toLocaleString('es-CL')
        }else{ //otros
          data['mc_despacho'] = parseFloat(data['mc_despacho']).toFixed(3)
          data['mc_recepcion'] = parseFloat(data['mc_recepcion']).toFixed(3)
          // data['cant_despacho'] = 1
          // data['cant_recepcion'] = 1
          data['precio'] = parseInt(data.precio)
          data['total'] = parseInt(data['mc_recepcion']) > 0 ? parseInt(data['precio'] * data['mc_recepcion']).toFixed(0) : parseInt(data['precio'] * data['cant_recepcion']).toFixed(0)
          data['total_mask'] = data['total'].toLocaleString('es-CL')          
        }
      }else{ 
        data['largo'] = parseFloat(data.largo).toFixed(3)
        data['alto'] = parseFloat(data.alto).toFixed(3)
        data['ancho'] = parseFloat(data.ancho).toFixed(2)
        data['espesor'] = parseFloat(data.espesor).toFixed(2)
        if(newValue.nombre !== undefined)
          if (newValue.nombre.trim().length > 0) {
            data[field] = newValue.id +'-'+ newValue.nombre
            data['producto_obj'] = {'id': newValue.id, 'nombre': newValue.nombre},
            messages.value = []
            configColumns()
          }else event.preventDefault()   
      }
    }

    const configColumns = () => {
      columns.value.map((col) => {
        if(form.tipoMadera.id === 7){
          col.hidden = /total_mask|producto_obj|diametro|alto|mruma_/.test(col.field) ? true : false
          csr1.value = 5
          csr2.value = 12
        }else if(form.tipoMadera.id === 9 ){
          col.hidden = /total_mask|producto_obj|espesor|ancho|alto|pulg_|mruma_/.test(col.field) ? true : false    
          csr1.value = 2         
          csr2.value = 9          
        }else if(form.tipoMadera.id === 10 ){
          col.hidden = /total_mask|producto_obj|diametro|espesor|cant_|mruma_|pulg_/.test(col.field) ? true : false 
          csr1.value = 3
          csr2.value = 8
        }else if(form.tipoMadera.id === 11){
          col.hidden = /total_mask|producto_obj|diametro|espesor|cant_|mc_|pulg_/.test(col.field) ? true : false 
          csr1.value = 3
          csr2.value = 8
        }else{ 
          col.hidden = /total_mask|producto_obj|diametro|espesor|ancho|alto|largo|pulg_|mruma_/.test(col.field) ? true : false 
          csr1.value = 2
          csr2.value = 7
        }                           
      })
    }

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value)
    }

    const toggleDelete= (index) => {
      lineas.value.splice(index, 1)
      messages.value = []
    }

    const upperCase = ($event, field) => {
      form[field] = $event.toUpperCase()
    }    

    const saveRecepcion = () => {
      // --- BLOQUE DE DIAGNÓSTICO ---
      // console.log('--- DIAGNÓSTICO VOLUMEN ---');
      const p = JSON.parse(JSON.stringify(form.predio || {}));
      // console.log('Objeto Predio:', p);
      // console.log('Valores:', { max: p.volumen_maximo, rec: p.volumen_recibido });

      dummyClick();
      submitted.value = true;
      messages.value = [];
      
      // 1. Cálculo de totales de recepción (M3)
      let _totalM3Recepcion = totalM3Recepcion._value !== undefined ? parseFloat(totalM3Recepcion._value) : 0;
      const valorMR = parseFloat(totalMRRecepcion?._value) || 0;
      _totalM3Recepcion += valorMR * 1.57;

      // 2. Cálculo SEGURO de disponibilidad
      let _dispPredioM3 = Number.MAX_SAFE_INTEGER;
      
      if (form.tipoMadera && (form.tipoMadera.id === 9 || form.tipoMadera.id === 11)) {
        // Si NO hay volumen_maximo definido en el objeto, usamos el valor infinito
        // para que la validación pase (asumimos que no hay restricción).
        if (form.predio?.volumen_maximo !== undefined && form.predio?.volumen_maximo !== null) {
            const volMax = parseFloat(form.predio.volumen_maximo) || 0;
            const volRec = parseFloat(form.predio.volumen_recibido) || 0;
            _dispPredioM3 = volMax - volRec;
        }
      }

      // console.info(`Comparación Final: ${_dispPredioM3} vs ${_totalM3Recepcion}`);
      // console.log(form)

      // 3. Lógica de validación por Tipo de Madera
      if (form.tipoMadera && (form.tipoMadera.id === 9 || form.tipoMadera.id === 11)) {
        // Agregamos un pequeño margen de error (0.001) para evitar problemas de precisión decimal
        if (_dispPredioM3 >= (_totalM3Recepcion - 0.001)) {
          validarYEnviar();
        } else {
          const vMax = form.predio?.volumen_maximo || 0;
          const vRec = form.predio?.volumen_recibido || 0;
          messages.value = [{ 
            content: `El predio ha superado el volumen: Máx(${vMax}), Recibido(${vRec}), Esta Guía(${_totalM3Recepcion.toFixed(2)})`, 
            id: 'vol-error' 
          }];
        }
      } else {
        validarYEnviar();
      }

      // 4. Sub-función de envío
      function validarYEnviar() {
        if (form.chofer !== null || (form.rut_dv !== null && form.nombre !== null)) {
          if (v$.value && !v$.value.$invalid) {
            if (lineas.value.length > 0) {
              form.detalles = lineas;
              storeRecepcion(form);
            } else {
              messages.value = [{ content: 'Debe seleccionar productos antes de guardar', id: 'det-err' }];
            }
          } else {
            messages.value = [{ content: 'Existen campos obligatorios pendientes por completar.', id: 'vuel-err' }];
          }
        } else {
          messages.value = [{ content: 'Debe seleccionar un chofer o indicar los datos de uno nuevo', id: 'chof-err' }];
        }
      }
    };

    const addLinea = () => {
      let row = {
        'producto_obj' : '',
        'producto' : '',
        'diametro' : 0,
        'espesor' : 0,
        'alto' : 0,
        'largo' : 0,
        'ancho' : 0,
        'cant_despacho' : 0,
        'mc_despacho' : 0,
        'mruma_despacho' : 0,
        'pulg_despacho' : 0,
        'cant_recepcion' : 0,
        'mc_recepcion' : 0,
        'mruma_recepcion' : 0,
        'pulg_recepcion' : 0,
        'precio' : 0,
        'total' : 0,
        'total_mask' : 0
      }
      
      if(lineas.value.length === 0)
        lineas.value.unshift(row)
      else
        if(lineas.value[lineas.value.length - 1].producto_obj !== '')
          lineas.value.unshift(row)
        else
          messages.value = [{ content: 'Debe seleccionar el producto antes de agregar nueva línea', id: lineas.value.length }]
      setProductos()
    }

    const totalCantDespacho = computed(() => {
      let cantDespacho = 0;
      for(let ln of lineas.value) {
        cantDespacho += Number(ln.cant_despacho)
      }
      form.cant_despacho = cantDespacho
      return cantDespacho
    })

    const totalM3Despacho = computed(() => {
      let m3Despacho = 0;
      for(let ln of lineas.value) {
        m3Despacho += Math.round(ln.mc_despacho * 1000 ) / 1000
      }
      form.mc_despacho = m3Despacho
      return m3Despacho
    })

    const totalMRDespacho = computed(() => {
      let mrDespacho = 0;
      for(let ln of lineas.value) {
        mrDespacho += Math.round(ln.mruma_despacho * 1000 ) / 1000
      }
      form.mruma_despacho = mrDespacho
      return mrDespacho
    })

    const totalCantRecepcion = computed(() => {
      let cantRecepcion = 0;
      for(let ln of lineas.value) {
        cantRecepcion += Number(ln.cant_recepcion)
      }
      form.cant_recepcion = cantRecepcion
      return cantRecepcion
    })

    const totalM3Recepcion = computed(() => {
      let m3Recepcion = 0;
      for(let ln of lineas.value) {
        m3Recepcion += Math.round(ln.mc_recepcion * 1000 ) / 1000
      }
      form.mc_recepcion = m3Recepcion
      return m3Recepcion
    })

    const totalMRRecepcion = computed(() => {
      let mrRecepcion = 0;
      for(let ln of lineas.value) {
        mrRecepcion += Math.round(ln.mruma_recepcion * 1000 ) / 1000
      }
      form.mruma_recepcion = mrRecepcion
      return mrRecepcion
    })    

    const netoRecepcion = computed(() => {
      let neto = 0;
      for(let ln of lineas.value) {
        neto += Number(ln.total)
      }
      form.neto = neto
      return formatCurrency(neto)
    })

    const ivaRecepcion = computed(() => {
      let iva = 0;
      iva = form.neto * form.poriva / 100
      form.iva = iva
      return formatCurrency(iva)
    })

    const totalRecepcion = computed(() => {
      let total = 0;
      total = form.neto + form.iva
      form.total = form.neto + form.iva
      return formatCurrency(total)
    })

// Decimales por campo según tipo de madera: la cantidad solo acepta decimales
// en tipo "otros" (ej. producto 186 Tonelada lampazo); baza/trozo cuentan piezas enteras
const getDecimals = (field) => {
  if (/alto|largo|mc|mruma/.test(field)) return 3
  if (/precio|total|total_mask|espesor|pulg|diametro/.test(field)) return 0
  if (/cant/.test(field)) return [7, 9, 10, 11].includes(form.tipoMadera.id) ? 0 : 2
  return 2
}

const formatForm = (value, decimals) => {
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;

  // toFixed asegura el punto decimal (.) y rellena con ceros (90.000)
  return num.toFixed(decimals);
};



    const setProductos = () => {
      const currentProveedorId = form.proveedor?.id || null;
      const currentOrigenId = form.origen?.id || null;

      // --- CASCADA NIVEL 1: CAMBIO DE PROVEEDOR ---
      if (currentProveedorId !== oldProveedorId.value) {
        manualCleaning.value = true;
        form.origen = null;  // Limpia el nivel 2
        form.predio = null;  // Limpia el nivel 3
        form.rol = '';
        form.fsc_nombre = '';
        form.fsc_codigo = '';
        
        oldProveedorId.value = currentProveedorId;
        oldOrigenId.value = null; // Resetear origen viejo también
        
        setTimeout(() => { manualCleaning.value = false; }, 300);
      } 
      
      // --- CASCADA NIVEL 2: CAMBIO DE ORIGEN ---
      // Solo si el proveedor es el mismo pero el origen CAMBIÓ
      else if (currentOrigenId !== oldOrigenId.value) {
        manualCleaning.value = true;
        form.predio = null;  // Limpia el nivel 3
        form.rol = '';
        form.fsc_nombre = '';
        form.fsc_codigo = '';

        oldOrigenId.value = currentOrigenId;
        
        setTimeout(() => { manualCleaning.value = false; }, 300);
      }

      // --- LÓGICA DE CARGA NORMAL ---
      if (form.proveedor !== null) setPredios();

      // Lógica de productos (solo si los 3 campos están llenos)
      if (currentOrigenId && currentProveedorId && form.tipoMadera?.id) {
        selectedProductos.value = [];
        getProdsRecep(currentOrigenId, currentProveedorId, form.tipoMadera.id);
      }
    };

    const buscarCodFscProveedor = () => {
      let proveedor = isProxy(form.proveedor) ? toRaw(form.proveedor) : null
      if(proveedor) getCodFsc(proveedor.id)
    }

    const setFscCodigo = (event) => {
      const selectedId = event.value;
      const selected = predioFscs.value.find(f => f.id === selectedId);
      form.fsc = selectedId;
      form.fsc_codigo = selected?.codigo || '';
    };

    const setRol = (selectedPredio) => {
      // Asumimos que selectedPredio ya es el objeto validado por el watcher
      form.rol = selectedPredio.rol || '';
      
      // Tu lógica de FSC (objeto o array según vimos en tu consola)
      const fscData = Array.isArray(selectedPredio.fscs) ? selectedPredio.fscs[0] : selectedPredio.fscs;

      if (fscData && (fscData.id || fscData.codigo)) {
        form.fsc = fscData.id;
        form.fsc_nombre = fscData.nombre;
        form.fsc_codigo = fscData.codigo;
        form.fsc_status = 'ok';
      } else {
        form.fsc = null;
        form.fsc_nombre = 'N/A';
        form.fsc_codigo = 'N/A';
        form.fsc_status = 'error';
      }
    };

    const dummyClick = () => {
      document.getElementById('dummy').click()
    }
    
    const setPredios = () => {
      const proveedorId = form.proveedor?.id;
      const origenId = form.origen?.id;

      // 1. AVISAR AL WATCHER: Evita que el "ancla" bloquee la limpieza
      manualCleaning.value = true;
      
      form.predio = null;
      form.rol = '';
      form.fsc = null;
      form.fsc_nombre = '';
      form.fsc_codigo = '';
      form.fsc_status = null; // Limpia también el estado del cartel rojo

      if (proveedorId && origenId) {
        // Buscamos el proveedor en tu lista maestra
        const provMaestro = proveedores.value.find(p => p.id === proveedorId);
        
        if (provMaestro && provMaestro.predios) {
          // 2. FILTRADO: Asegúrate de que provMaestro.predios contenga 
          // volumen_maximo y volumen_recibido.
          predios.value = provMaestro.predios.filter(p => p.origen_id === origenId);
        } else {
          predios.value = [];
        }
      } else {
        predios.value = [];
      }

      // 3. CERRAR LLAVE
      setTimeout(() => { manualCleaning.value = false; }, 300);
    };

    const populatePredioFscs = (predio) => {
      predioFscs.value = (predio?.fscs || []).map(f => ({
        id: Number(f.id),
        nombre: f.nombre,
        codigo: f.codigo,
        _nombre: `${f.id}-${f.nombre}`
      }));
    };

    onMounted(() => {
      loading.value = true
      lazyParams.value = {
        first: dt.value.first,
        rows: dt.value.rows,
        sortField: null,
        sortOrder: null,
        filters: filters.value
      }
      loadLazyData()
    })

    const v$ = useVuelidate(rules, form)

    watch(() => form.predio, (newValue, oldValue) => {
      // 1. CARGA: Si elegimos un predio de la lista
      if (newValue && typeof newValue === 'object' && newValue.id) {
        setRol(newValue);
        return;
      }

      // 2. ESCUDO: Si es un cambio accidental (TAB), restauramos el valor
      if (!manualCleaning.value && typeof oldValue === 'object' && oldValue?.id) {
        if (typeof newValue === 'string' || newValue === null) {
          form.predio = oldValue; 
          return;
        }
      }

      // 3. LIMPIEZA: Si manualCleaning es true (CASCADA), reseteamos los hijos
      if (!newValue) {
        limpiarCampos(); // Limpia Rol, fsc_nombre, fsc_codigo, fsc_status
      }
    }, { deep: true });

    const limpiarCampos = () => {
      form.rol = '';
      form.fsc = null;
      form.fsc_nombre = '';
      form.fsc_codigo = '';
      form.fsc_status = null;
    };
    
    return {
      dt, 
      loading,
      saving,
      recepcion,
      chofer,
      tipoMadera,
      fsc,
      fscs,
      recepciones,
      productos,
      lineas,
      columns,
      choferes,
      tipoMaderas,
      tipoDocReceps,
      proveedores,
      predios,
      recepcionistas,
      transportistas,
      filters,
      selectedRecepciones,
      deleteRecepcionesDialog,
      deleteRecepcionDialog,
      recepcionDialog,
      submitted,
      filteredTipoDocReceps,
      filteredProveedores,
      filteredPredios,
      filteredRecepcionistas,
      filteredChoferes,
      filteredTipoMaderas,
      filteredDestinos,
      filteredOrigenes,
      filteredProductos,
      filteredTransportistas,
      selectedProductos,
      porciva,
      nextid,
      v$,
      form,
      messages,
      netoRecepcion,
      totalCantDespacho,
      totalM3Despacho,
      totalCantRecepcion,
      totalM3Recepcion,
      totalMRRecepcion,
      totalMRDespacho,
      ivaRecepcion,
      totalRecepcion, 
      upperCase,
      setProductos,     
      hideDialog,
      openNew,
      confirmDeleteRecepcion,
      deleteSelectedRecepciones,
      deleteRecepcion,
      addChofer,
      frmchofer,
      confirmDeleteSelected,
      searchTipoDocRecep,
      searchProducto,
      searchProveedor,
      searchRecepcionista,
      formatForm,
      getDecimals,
      searchChofer,
      searchDestino,
      searchTransportista,
      searchOrigen,
      searchTipoMadera,
      editRecepcion,
      saveRecepcion,
      storeRecepcion,
      formatCurrency,
      onCellEditComplete,
      addLinea,
      toggleDelete,
      buscarCodFscProveedor,
      getCodFsc,
      setFscCodigo,
      csr1,
      csr2,
      configColumns,
      oldTMadera,
      recepcionPDF,
      informeData,
      totalRecords,
      first,
      lazyParams,
      loadLazyData,
      onPage,
      onSort,
      onFilter,
      duplicarGuia,
      getPDFSII,
      dummyClick,
      initFilters,
      setPredios,
      searchPredio,
      setRol,
      predioFscs,
      populatePredioFscs,
      limpiarCampos
    }
  },
}
</script>